import { render, staticRenderFns } from "./NewsfeedForm.vue?vue&type=template&id=171cd4f5&scoped=true&"
import script from "./NewsfeedForm.vue?vue&type=script&lang=js&"
export * from "./NewsfeedForm.vue?vue&type=script&lang=js&"
import style0 from "./NewsfeedForm.vue?vue&type=style&index=0&id=171cd4f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171cd4f5",
  null
  
)

export default component.exports